module.exports = __webpack_public_path__ + "img/Neo-Tips-Pic2.e223620e.png";